import React, { useState, useEffect, useRef } from "react";
//assets
import arrowOff from "img/QuoteDropDownOff.svg";
import arrowOn from "img/QuoteDropDownOn.svg";
//components
import { Column, Row } from "components/Layout/Grid";
import Text from "components/Text";
//styles
import "../QuoteStatusFilter/style.scss";

interface DisplayGridFilterProps {
  selectedGridOption: 0 | 1 | 2;
  setSelectedGridOption: (value: 0 | 1 | 2) => void;
}

const DisplayGridFilter: React.FC<DisplayGridFilterProps> = (props) => {
  const { selectedGridOption, setSelectedGridOption } = props;

  const [open, setOpen] = useState<boolean>(false);
  const [style, setStyle] = useState<string>("none");
  const [arrow, setArrow] = useState<string>(arrowOff);

  const dropdownMenu: any = useRef(null);

  const handleOpenCloseDropDownMenu = () => {
    if (open === false) {
      setOpen(true);
      setStyle("block");
      setArrow(arrowOn);
    } else {
      setOpen(false);
      setStyle("none");
      setArrow(arrowOff);
    }
  };

  const closeOpenMenus = (e: any) => {
    if (dropdownMenu?.current && open && !dropdownMenu?.current.contains(e.target)) {
      handleOpenCloseDropDownMenu();
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", closeOpenMenus);
  }, [open]);

  const handleGridOptionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const v = Number(event.target.value) as 0 | 1 | 2;
    setSelectedGridOption(v);
  };

  const options = [
    { value: 0, label: 'Todos os Pedidos' },
    { value: 1, label: 'Novos Resgates' },
    { value: 2, label: 'Pedidos já Baixados' }
  ];

  const selectedLabel = options.find(opt => opt.value === selectedGridOption)?.label || 'Todos os Pedidos';

  return (
    <Row className="w-md-100">
      <Column className="w-md-100">
        <Row>
          <Text className="StatusFilterLabel" size={12}>
            Exibir
          </Text>
        </Row>
        <div ref={dropdownMenu}>
          <Row>
            <Column className="w-md-100">
              <div
                className="StatusFilterDropDown w-md-100"
                style={{ borderColor: open ? "#0E4C54" : "#BEBEBE" }}
                onClick={() => {
                  handleOpenCloseDropDownMenu();
                }}
              >
                <Text size={12}>{selectedLabel}</Text>
                <img alt="arrow icon" src={arrow} />
              </div>
            </Column>
          </Row>
          <Row>
            <div className="StatusFilterOptionsArea" style={{ display: style }}>
              <div>
                <ul>
                  {options.map((option) => (
                    <li key={option.value}>
                      <div className="StatusFilterStatusRadio">
                        <input
                          type="radio"
                          onChange={handleGridOptionChange}
                          value={option.value}
                          name="gridOption"
                          checked={selectedGridOption === option.value}
                        />
                        <label htmlFor="StatusFilterStatusLabel">{option.label}</label>
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </Row>
        </div>
      </Column>
    </Row>
  );
};

export default DisplayGridFilter;

